<template>
  <div class="importDialog">
    <el-dialog
      title="导入考生信息"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      class="importfile"
      :before-close="handleCloseDialog"
      :show-close="false"
      :lock-scroll="false"
    >
      <div class="main">
        <div class="userInfoFile">
          <div class="text">导入考生人员信息：</div>
          <div class="importbox">
            <el-upload
              action=""
              :on-remove="handleFileRemove"
              accept=".xls,.xlsx"
              :limit="1"
              :file-list="fileList"
              :http-request="handleFileRequestImport"
            >
              <el-button type="primary">导入文件</el-button>
            </el-upload>
            <el-button type="primary" class="downLoadBtn" @click="handleDownoadTemplate"
              >下载模板</el-button
            >
          </div>
        </div>
        <div class="userAppends">
          <div class="text">导入考生人员附件：</div>
          <div class="importbox">
            <!-- <div style="margin-bottom:20px">
              <el-cascader
                v-model="jobList"
                placeholder="证书名称和登记"
                :options="certifiterList"
                class="input-width"
                :props="{
                  checkStrictly: true,
                  value: 'jobId',
                  label: 'jobName',
                  children: 'levelList',
                }"
                clearable
                @change="handleJobLevelChange"
              ></el-cascader>
            </div> -->
            <el-upload
              action=""
              :on-remove="handleAppendixRemove"
              accept=".zip,.doc,.docx,.pdf,.png,.jpg,.jpge"
              :limit="1"
              :file-list="appendixList"
              :http-request="appendixRequestImport"
            >
              <el-button type="primary">导入附件</el-button>
            </el-upload>
            <div class="tips">
              <div>注意事项：</div>
              <div>1.导入附件需要先选择人员报名的证书。</div>
              <div>2.附件支持格式：zip，doc，docx，pdf，png，jpg，jpge。</div>
              <div>
                3.批量上传：zip格式会解压第1级文件，内部文件夹按文件名“姓名-身份证-证书名-等级”解析，文件夹下所有文件，按该文件夹身份证信息和证书等级归纳到同身份证号的学员名下绑定。
              </div>
              <div>
                4.单个考生文件夹里的文件，会识别固定的名称来识别文件数据规划到对应字段，如：身份证照片正，身份证照片背，登记照，毕业证照片，工作证明，参保证明。
              </div>
              <div>
                5.单个文件上传：例如doc，docx，pdf，png，jpg，jpge格式直接按文件名“姓名-身份证-证书名-等级”解析，文件按身份证信息归纳到同身份证号的学员名下绑定。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleCloseDialog">关闭</el-button>
      </div>
    </el-dialog>
    <ErrorDialog ref="ErrorDialog" @error="handleLoadListFn"></ErrorDialog>
  </div>
</template>
<script>
import to from 'await-to'
import { applyModelDownLoad, applyUserFileImport, applyUserAppendixImport } from '@/api/apply'
// import { filterJobLevel } from '@/api/exam'
import ErrorDialog from './errorDialog'
export default {
  name: 'ImportDialog',
  components: {
    ErrorDialog,
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      appendixList: [],
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList
    },
    async handleFileRequestImport(file) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const params = new FormData()
      params.append('file', file.file)
      const [, err] = await to(applyUserFileImport(params))
      loading.close()
      this.fileList = []
      if (err) {
        loading.close()
        return this.$message({
          type: 'warning',
          dangerouslyUseHTMLString: true,
          message: err.msg,
          duration: 5000,
        })
      }
      this.$message({ type: 'success', message: '导入成功', duration: 5000 })
      this.dialogVisible = false
      this.$emit('success')
    },
    //附件导入
    handleAppendixRemove(file, fileList) {
      this.appendixList = fileList
    },
    async appendixRequestImport(file) {
      // if (!this.jobLevel) {
      //   this.appendixList = []
      //   return this.$message({
      //     type: 'warning',
      //     message: '请选择证书和等级',
      //     duration: 5000,
      //   })
      // }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const params = new FormData()
      params.append('file', file.file)
      params.append('jobId', this.jobId)
      params.append('jobLevel', this.jobLevel)
      const [, err] = await to(applyUserAppendixImport(params))
      loading.close()
      this.appendixList = []
      if (err) {
        loading.close()
        return this.$refs.ErrorDialog.show(err.msg)
        // return this.$message({
        //   type: 'warning',
        //   dangerouslyUseHTMLString: true,
        //   message: err.msg,
        //   duration: 5000,
        // })
      }
      this.$message({ type: 'success', message: '导入成功', duration: 5000 })
      this.dialogVisible = false
      this.$emit('success')
      // this.jobList = []
      // this.jobId = ''
      // this.jobLevel = ''
    },
    handleCloseDialog() {
      this.dialogVisible = false
      // this.jobList = []
      // this.jobId = ''
      // this.jobLevel = ''
    },
    async handleDownoadTemplate() {
      const [res, err] = await to(applyModelDownLoad({}))
      if (err) return this.$message.error(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '报名资料模板.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleLoadListFn() {
      this.$emit('success')
    },
  },
}
</script>
<style lang="scss" scoped>
.importfile {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 30px 40px;
      .userInfoFile {
        display: flex;
        .text {
          font-size: 16px;
          line-height: 36px;
          margin-right: 20px;
        }
        .importbox {
          display: flex;
        }
        .el-button {
          width: 170px;
          height: 36px;
          border-radius: 2px;
          font-weight: normal;
          font-size: 14px;
        }
        .downLoadBtn {
          margin-left: 30px;
        }
      }
      .userAppends {
        display: flex;
        margin-top: 30px;
        .text {
          font-size: 16px;
          line-height: 36px;
          margin-right: 20px;
          flex-shrink: 0;
        }
        .el-button {
          width: 170px;
          height: 36px;
          border-radius: 2px;
          font-weight: normal;
          font-size: 14px;
        }
        .tips {
          margin-top: 20px;
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>
